import {getEnv} from '../../common/env/env';
import {GotchaStatusVo} from '../../common/shared/api/nicolas/vo/enums/GotchaStatusVo.enum';
import {GotchaTypeVo} from '../../common/shared/api/nicolas/vo/enums/GotchaTypeVo.enum';
import {GotchaMainResponseVo} from '../../common/shared/api/nicolas/vo/GotchaMainResponseVo.interface';
import {DEFAULT_CASH_DATA} from '../../domain/gacha-old/constant';
import {GotchaInfo} from '../generated/types';
import {createGotchaEntryType} from './GotchaEntryType';
import {createGotchaStatus} from './GotchaStatus';
import {createGotchaType} from './GotchaType';
import {createWinPrizeType} from './WinPrizeType';

export function createGotchaInfo(
  data: GotchaMainResponseVo & {gotcha_id: string}
): GotchaInfo {
  const kageUrlPrefix = getEnv().kageUrlPrefix;
  return {
    gotchaId: data.gotcha_id,
    title: data.title || '',
    entryType: createGotchaEntryType(data.entry_type),
    bgImg: data.background_img
      ? `${kageUrlPrefix}${data.background_img}`
      : data.type === GotchaTypeVo.Standalone
        ? DEFAULT_CASH_DATA.bgImg
        : '',
    bgColor:
      data.background_color ||
      (data.type === GotchaTypeVo.Standalone
        ? DEFAULT_CASH_DATA.bgColor
        : '#000000'),
    spinWheelReadyImgs: data.spin_wheel_ready_imgs
      ? data.spin_wheel_ready_imgs
          .split(',')
          .map(img => `${kageUrlPrefix}${img}`)
      : data.type === GotchaTypeVo.Standalone
        ? DEFAULT_CASH_DATA.centerReadyImgs
        : [],
    spinWheelImgs: data.spin_wheel_imgs
      ? data.spin_wheel_imgs.split(',').map(img => `${kageUrlPrefix}${img}`)
      : data.type === GotchaTypeVo.Standalone
        ? DEFAULT_CASH_DATA.centerDrawImgs
        : [],
    extBannerImg: data.ext_banner_img
      ? `${kageUrlPrefix}${data.ext_banner_img}`
      : undefined,
    extBannerLink: data.ext_banner_link ? data.ext_banner_link : undefined,
    belowDesc: data.below_desc,
    resultImg: data.result_img
      ? `${kageUrlPrefix}${data.result_img}`
      : data.type === GotchaTypeVo.Standalone
        ? DEFAULT_CASH_DATA.centerCleanResultImg
        : '',
    topTitleImg: data.top_title_img
      ? `${kageUrlPrefix}${data.top_title_img}`
      : data.type === GotchaTypeVo.Standalone
        ? DEFAULT_CASH_DATA.topImg
        : '',
    type: createGotchaType(data.type),
    adLocId: data.ad_loc_id,
    bannerAdLocId: data.banner_ad_loc_id,
    status: createGotchaStatus(data.status),
    buttonImg: data.button_img
      ? `${kageUrlPrefix}${data.button_img}`
      : data.type === GotchaTypeVo.Standalone &&
          data.status === GotchaStatusVo.First
        ? DEFAULT_CASH_DATA.mainBtnImg
        : undefined,
    spinWheelDesc: data.spin_wheel_desc ? data.spin_wheel_desc : undefined,
    winPrizeType: data.win_prize_type
      ? createWinPrizeType(data.win_prize_type)
      : undefined,
    winPrize: data.win_prize,
    receiveDate: data.receive_date,
    expireDateText: data.expire_date_text,
    maxCash: data.max_cash,
    buttonColor: data.button_color,
  };
}
